import React from "react"
import logo from "./logo.svg"
import "./App.css"

import { observer, inject } from "mobx-react"

import AttributeWindow from "./components/AttributeWindow"
import BalanceWindow from "./components/BalanceWindow"
import ProfileForm from "./components/ProfileForm"
import ProfileList from "./components/ProfileList"
import Code from "./components/Code"
import Pulse from "./components/Pulse"
import Share from "./components/Share"

import BGCode from "./data/code"

class App extends React.Component {
  handleSaveProfile(data) {
    this.props.app.action.addProfile(data.name, data.mbti)
  }

  handleRemove(index) {
    this.props.app.action.removeProfile(index)
  }

  render() {
    const { app } = this.props

    const hasProfiles = app.profiles.length > 0
    return (
      <div className="App">
        {hasProfiles ? <Share /> : null}
        {hasProfiles ? <Code code={BGCode} /> : null}
        {hasProfiles ? <Pulse /> : null}
        <header>
          {app.promptForProfile ? (
            <div className="App__overlay">
              <ProfileForm
                onSave={this.handleSaveProfile.bind(this)}
                onCancel={() => app.action.prompt(false)}
                showClose={app.canClosePrompt}
              />
            </div>
          ) : null}
          <ProfileList />
        </header>
        <div className="App__content">
          {hasProfiles ? <AttributeWindow store={this.props.app} /> : null}
          {hasProfiles ? (
            <div className="App__balance">
              <BalanceWindow
                title="Attributes by most developed"
                traits={app.orderedTraits}
                size={app.size}
              />
              {/* <BalanceWindow
                title="Least developed"
                traits={app.weakestTraits}
              /> */}
            </div>
          ) : null}
        </div>
        <footer>
          Created by <a href="https://twitter.com/wmdmark">@wmdmark</a>.
        </footer>
      </div>
    )
  }
}

export default inject(["app"])(observer(App))



// WEBPACK FOOTER //
// ./src/App.js